export default class ServiceResult<T> {
    constructor(success: boolean, message = "") {
        this.success = success
        this.message = message
    }

    success = false
    message = ""
    data: T | null = null
}